module.exports = __webpack_public_path__ + "static/media/TERRA_NOSTRA.b1ea159d.svg";